// test817
(817 && 0);
